import { makeStyles } from "@material-ui/core";

export const useReservationStyles = makeStyles((theme) => ({
  page: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "8px 4px",
  },
  panel: {
    background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
    borderRadius: "16px",
    padding: "14px 20px",
    boxShadow: "0 2px 12px rgba(0,68,103,0.08)",
    border: "1px solid #e8edf2",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  twoCol: {
    display: "flex",
    gap: "16px",
    alignItems: "flex-start",
    // Stack the area sidebar above the main content on phones so neither is squeezed.
    [theme.breakpoints.down("sm")]: { flexDirection: "column" },
  },
  sidebar: {
    width: "220px",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    [theme.breakpoints.down("md")]: { width: "190px" },
    [theme.breakpoints.down("sm")]: { width: "100%" },
  },
  mainContent: {
    flex: 1,
    minWidth: 0,
  },
  // kept for legacy references in other views
  container: {
    display: "flex",
    flexDirection: "column",
  },
  modalContent: {
    width: "45%",
    maxWidth: "45rem",
    [theme.breakpoints.down("md")]: { width: "90vw" },
  },
  datePicker: {
    marginBottom: "1rem",
  },
  inputConts: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(10rem, 1fr))",
    gap: "1rem",
    rowGap: "1rem",
  },
  radio: {
    "&.Mui-checked": {
      color: "rgba(255, 138, 0, 0.71)",
    },
  },
  submitBtn: {
    marginRight: "1rem",
  },
  btnWrapper: {
    marginTop: "1rem",
  },
  modal: {
    width: "30rem",
    maxWidth: "95vw",
    padding: "1rem",
    [theme.breakpoints.down("sm")]: { width: "100%" },
  },
  tabs: {
    width: "27rem",
    maxWidth: "100%",
  },
  loaderCont: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: "2000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
